import * as React from "react";
import moment from "moment";
import axios from "axios";
import { useEffect } from "react";
import "../../proposols/step1/proposol.css";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { set_info1 } from "../../../Redux/action";
import { Col, Form,Input, Row,Select,Button,InputNumber,Collapse,DatePicker} from "antd/lib";
import { EditOutlined,CalendarOutlined } from "@ant-design/icons";
import Son1Proposerdisplay from "../InfoDisplay/Son1ProposerDisplay";

function Son1PropDetail({setSon1PropDisplay,Son1PropDisplay,isAllPresent}) {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { Panel } = Collapse;
  const [formLayout] = useState('vertical');
  const dispatch = useDispatch();
  const history = useHistory();
  const reg = useSelector((state) => state?.healthdetail?.healthnum);
  const OwnerInfo = useSelector((state) => state?.addressdetail?.info1);
  const PersonsDetail = useSelector((state) => state?.healthdetail?.famdetail?.healthdetail);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeKey, setActiveKey] = useState(["1", "2",]);
  const [Age, setAge] = useState(OwnerInfo?.Son1 ? OwnerInfo?.Son1?.age : '');
  const [dob, setDob] = useState("");

  useEffect(()=>{
    setSon1PropDisplay(isAllPresent)
  },[isAllPresent])

  const disabledDate = (current) => {
    const today = moment();
    const minDate = today.clone().subtract(30, "years");

    return current.isBefore(minDate, "day") || current.isAfter(today, "day");
};


  const calculateAge = (date) => {
    const dateString = moment(date).format("YYYY-MM-DD");
    setDob(dateString);
    const dobObject = new Date(date); 
    const ageDifMs = Date.now() - dobObject.getTime();

    const ageDate = new Date(ageDifMs); 
    const ageInYears = Math.abs(ageDate.getUTCFullYear() - 1970).toString();
    // console.log(ageInYears);
    if (ageInYears === "53") {
      setAge("");
    } else {
      setAge(ageInYears);
    }
    // console.log(Age);
  };

  const onFinish = (values) => {
    setLoading(true)
    // console.log(values)
    var Son1 = {
      title: values?.title,
      Son1Name : values?.fullName,
      SonBloodGroup: values?.bloodGroup,
      SonHeight: values?.height,
      SonInches: values?.inches,
      SonWeight: values?.weight,
      dateofbirth: moment(values?.dateofbirth).format('YYYY-MM-DD'),
      age: Age
    }
    // console.log(data)
    dispatch(set_info1({...OwnerInfo,Son1}))
    setTimeout(()=>{
      setLoading(false)
      setSon1PropDisplay(true)
      },500)
  }
 
  // console.log(PersonsDetail)
  const onChange = (keys) => {
    console.log(keys);
    setActiveKey(keys);
  };
  const customerEditSon = () => {
    setSon1PropDisplay(false)
  }

  return (
    <>
    {Son1PropDisplay ?
    <>
    <div className="edit-prop-detail">
    <EditOutlined onClick={customerEditSon} />
    </div>
        <Son1Proposerdisplay/>
    </>
    :
      <div className="gridparent-skb">
        <Form
            layout={formLayout}
            form={form}
            style={{paddingTop: "10px"}}
            //requiredMark={false}
            onFinish={onFinish}
            scrollToFirstError
            >
              <Row gutter={24}>
              <Col span={4}>
                  <Form.Item 
                    label="Title"
                    name='title'
                    rules={[{
                    required: true, 
                    message: 'please Select title'
                    }]}
                    initialValue={OwnerInfo?.Son1?.title}
                    >
                     <Select
                     placeholder='Mr/Mrs'
                        options={[
                          {
                            value: 'Mr',
                            label: 'Mr',
                          },
                          {
                            value: 'Mrs',
                            label: 'Mrs',
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                <Col span={20}>
                  <Form.Item 
                    label="Full Name"
                    name='fullName'
                    rules={[
                        {
                        required: true, 
                        message: 'Please input your name'
                        },
                        {
                        validator: (_, value) => {
                            const nameParts = value.trim().split(' '); // Trim whitespace and split the name
                            
                            // Check if there are at least two parts (first name and second name/initial)
                            if (nameParts.length < 2) {
                            return Promise.reject('Please enter your full name with a second name or initial.');
                            }
                            
                            // Check if the last part is not just a dot
                            if (nameParts[nameParts.length - 1] === '.') {
                            return Promise.reject('Please enter a valid second name or initial.');
                            }
                            
                            return Promise.resolve();
                        },
                        },
                    ]}
                    initialValue={OwnerInfo?.Son1?.Son1Name}
                    >
                    <Input style={{ width: "100%" }} placeholder="Full Name" />
                    </Form.Item>
                </Col>
                <Col span={8}>
                        <Form.Item
                          label="Date of Birth"
                          name="dateofbirth"
                          rules={[
                            {
                              required: true,
                              message: "Please select DOB",
                            },
                          ]}
                          initialValue={
                            OwnerInfo?.Son1?.dateofbirth
                              ? moment(OwnerInfo?.Son1?.dateofbirth)
                              : null
                          }
                        >
                          <DatePicker
                            suffixIcon={
                              Age ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      marginRight: "4px",
                                      color: "#0000ff94",
                                    }}
                                  >
                                    {Age} Years
                                  </span>
                                  <CalendarOutlined />
                                </div>
                              ) : (
                                <CalendarOutlined />
                              )
                            }
                            style={{ width: "100%", padding: "8px 10px" }}
                            disabledDate={disabledDate}
                            format="YYYY-MM-DD"
                            onChange={calculateAge}
                            // defaultPickerValue={getDefaultPickerValue()}
                            placeholder="YYYY-MM-DD"
                          />
                        </Form.Item>
                      </Col>
                <Col span={4}>
                  <Form.Item 
                    label="Blood Group"
                    name='bloodGroup'
                    rules={[{
                    required: true, 
                    message: 'please Select Blood Group'
                    }]}
                    initialValue={OwnerInfo?.Son1?.SonBloodGroup}
                    >
                     <Select
                     placeholder='Blood group'
                        options={[
                          {
                            value: 'A+',
                            label: 'A+',
                          },
                          {
                            value: 'A-',
                            label: 'A-',
                          },
                          {
                            value: 'B+',
                            label: 'B+',
                          },
                          {
                            value: 'B-',
                            label: 'B-',
                          },
                          {
                            value: 'AB+',
                            label: 'AB+',
                          },
                          {
                            value: 'AB-',
                            label: 'AB-',
                          },
                          {
                            value: 'O+',
                            label: '0+',
                          },
                          {
                            value: 'O-',
                            label: '0-',
                          },
                          {
                            value: 'Not Provided',
                            label: 'Not Provided',
                          },
                          {
                            value: 'Not Available',
                            label: 'Not Available',
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                <Col span={4}>
                  <Form.Item 
                    label="Height"
                    name='height'
                    rules={[{
                    required: true, 
                    message: 'please Select Height'
                    }]}
                    initialValue={OwnerInfo?.Son1?.SonHeight}
                    >
                     <Select
                     placeholder='ft'
                        options={[
                          {
                            value: '1 feet',
                            label: '1 feet',
                          },
                          {
                            value: '2 feet',
                            label: '2 feet',
                          },
                          {
                            value: '3 feet',
                            label: '3 feet',
                          },
                          {
                            value: '4 feet',
                            label: '4 feet',
                          },
                          {
                            value: '5 feet',
                            label: '5 feet',
                          },
                          {
                            value: '6 feet',
                            label: '6 feet',
                          },
                          {
                            value: '7 feet',
                            label: '7 feet',
                          },
                          {
                            value: '8 feet',
                            label: '8 feet',
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                  <Form.Item 
                    label="Inches"
                    name='inches'
                    rules={[{
                    required: true, 
                    message: 'please Select Inches'
                    }]}
                    initialValue={OwnerInfo?.Son1?.SonInches}
                    >
                     <Select
                     placeholder='inches'
                        options={[
                          {
                            value: '0 inches',
                            label: '0 inches',
                          },
                          {
                            value: '1 inches',
                            label: '1 inches',
                          },
                          {
                            value: '2 inches',
                            label: '2 inches',
                          },
                          {
                            value: '3 inches',
                            label: '3 inches',
                          },
                          {
                            value: '4 inches',
                            label: '4 inches',
                          },
                          {
                            value: '5 inches',
                            label: '5 inches',
                          },
                          {
                            value: '6 inches',
                            label: '6 inches',
                          },
                          {
                            value: '7 inches',
                            label: '7 inches',
                          },
                          {
                            value: '8 inches',
                            label: '8 inches',
                          },
                          {
                            value: '9 inches',
                            label: '9 inches',
                          },
                          {
                            value: '10 inches',
                            label: '10 inches',
                          },
                          {
                            value: '11 inches',
                            label: '11 inches',
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                  <Form.Item 
                    label="Weight"
                    name='weight'
                    rules={[{
                    required: true, 
                    message: 'please Enter Weight'
                    }]}
                    initialValue={OwnerInfo?.Son1?.SonWeight}
                    >
                      <InputNumber
                      style={{width: '100%', padding: '4px'}}
                        formatter={(value) => `${value}kg`}
                        parser={(value) => value.replace('kg', '')}
                      />
                    </Form.Item>
                  </Col>
                  </Row>
                <Row gutter={24}>
                <Col span={24}>
                  </Col>
                <Col span={24}>
                  <Form.Item style={{textAlign: "center"}}>
                  {Son1PropDisplay ? null :
                    <Button
                     loading={loading}
                     style={{background: "#293890",border: "#293890"}}
                     type="primary" 
                     htmlType="submit">
                      Save Son Details
                    </Button> }
                  </Form.Item>
                </Col>
                </Row>
            </Form>
      </div> }
    </>
  );
}

export { Son1PropDetail };
